import { Box, createStyles, lighten, makeStyles, Typography } from '@material-ui/core';
import cn from 'classnames';
import * as React from 'react';
import { TranquiTheme } from '../../containers/App/theme';
import { getSpace } from '../../content/getSpace/getSpace';
import { SpaceContext } from '../../content/types/SpaceContext';
import useDictionary from '../../dictionaries/context/useDictionary';
import RenderText from '../../dictionaries/RenderText';
import { NegotiationOption, NegotiationOptionAlternative, OutDebt } from '../../generated/graphql';
import { getNegBooleans } from '../../utils/getNegBooleans';

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  box: {
    width: '100%',
    backgroundColor: theme.palette.marble.main,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(2),
    },
  },
  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
    rowGap: theme.spacing(1),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  title: {
    ...theme.typography.body1,
    color: theme.palette.indigo.main,
    backgroundColor: lighten(theme.palette.lavender.main, 0.95),
    borderRadius: theme.shape.borderRadius,
    fontWeight: 600,
    textAlign: 'center',
    textWrap: 'balance',
    padding: theme.spacing(1),
  },
  descriptionBox: {
    ...theme.typography.body2,
    backgroundColor: lighten(theme.palette.secondary.main, 0.95),
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
  },
}));

interface ExternalNegotiationInstructionsProps {
  debt: OutDebt;
  negOption: NegotiationOption;
  alternative: NegotiationOptionAlternative;
  className?: string;
}

const ExternalNegotiationInstructions: React.FC<ExternalNegotiationInstructionsProps> = (props) => {
  const { debt, negOption, alternative, className } = props;

  const classes = useStyles();
  const { gT, dictionary } = useDictionary();
  const extra = { gT, dictionary };

  const negBooleans = getNegBooleans(debt, negOption);
  const spaceContext: SpaceContext = {
    bank: debt.bank,
    brand: debt.brand!,
    country: debt.country!,
    outDebt: debt,
    option: negOption,
    negBooleans,
    alternative,
  };

  const titleSpace = getSpace('NEG_OPTION_EXTERNAL_INSTRUCTIONS', 'title', spaceContext, extra);
  const descriptionSpace = getSpace('NEG_OPTION_EXTERNAL_INSTRUCTIONS', 'description', spaceContext, extra);

  return (
    <Box className={cn(classes.box, className)}>
      <Box className={classes.contentBox}>
        <Typography className={classes.title} data-testid="external-negotiation-instructions__title">
          <RenderText
            isMarkdown
            textKey={titleSpace.key}
          />
        </Typography>
        <Box className={classes.descriptionBox} data-testid="external-negotiation-instructions__description-box">
          <RenderText
            isMarkdown
            textKey={descriptionSpace.key}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ExternalNegotiationInstructions;
